/**
 *
 * @param {number} rem
 * @returns {number}
 */
export default function remToPixels(rem) {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize) * window.devicePixelRatio;
}

